import React from "react";

// TODO: show both colors
function ConfigInsideColorRadioButton( props: {
	selected?: boolean;
	name: string;
	value: {
		fabricColorName: string;
		fabricColorCode: string;
		modulColor: string;
		modulColorCode: string;
		path: string;
	};
	callback: ( value: string ) => void
} ) {
	return <label
		title={props.value.fabricColorName}
		className={"config-button config-button-color" + ( props.selected ? " selected" : "" )}
		htmlFor={`${props.name}-${props.value.fabricColorName}`}
		style={{
			background: `linear-gradient(10deg,
			${props.value.fabricColorCode} 0%, 
			${props.value.fabricColorCode} 49%, 
			${props.value.modulColorCode} 51%, 
			${props.value.modulColorCode} 100%)`
		}}
	>
		<input
			type={"radio"}
			value={props.value.fabricColorName}
			id={`${props.name}-${props.value.fabricColorName}`}
			name={props.name}
			style={{
				display: "none",
			}}
			checked={props.selected ? true : undefined}
			onClick={() => props.callback( props.value.fabricColorName )}
		/>
	</label>
		;
}

export default ConfigInsideColorRadioButton;
